import { alpha } from '@mui/material/styles';
import { portfolioButtonStyles } from '../../../styles';

const styles = theme => ({
    ...portfolioButtonStyles(theme),
    dialogPaper: {
        borderRadius: '12px',
        padding: theme.spacing(2),
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingBottom: theme.spacing(1),
    },
    title: {
        fontWeight: 600,
        fontSize: '1rem',
        color: theme.palette.text.dark,
    },
    infoBox: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        padding: theme.spacing(1.25, 1.5),
        borderRadius: '8px',
        backgroundColor: alpha(theme.palette.primary.main, 0.08),
        border: `1px solid ${alpha(theme.palette.primary.main, 0.12)}`,
        color: theme.palette.primary.main,
        fontSize: '0.85rem',
    },
    sectionLabel: {
        fontWeight: 600,
        fontSize: '0.85rem',
        color: theme.palette.primary.main,
        marginTop: theme.spacing(1.5),
        marginBottom: theme.spacing(0.5),
    },
    formField: {
        marginBottom: theme.spacing(1.5),
    },
    loginButton: {
        width: '100%',
        marginTop: theme.spacing(0.5),
    },
    dividerRow: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1.5),
        color: theme.palette.text.label,
    },
    helperText: {
        fontSize: '0.85rem',
        color: theme.palette.text.label,
        textAlign: 'center',
    },
    createAccountButton: {
        width: '100%',
        marginTop: theme.spacing(1),
    },
    continueGuestButton: {
        textTransform: 'none',
        marginTop: theme.spacing(1.5),
    },
});

export default styles;
